import classNames from 'classnames';

import { Button, ChatButtonContent } from 'components/design-system/Button';
import { useTheme } from 'context/theme';
import { useViewport } from 'context/viewport';
import { intercomShowNewMessage } from 'lib/intercom';
import { Model, StyledComponent } from 'types';

import styles from './AnyQuestionsBanner.module.scss';
import { ConciergeVideo } from './ConciergeVideo';
import { ModelAvatar } from './ModelAvatar';

type AnyQuestionsBannerProps = {
  model: Model;
} & StyledComponent;

export const AnyQuestionsBanner: React.FC<AnyQuestionsBannerProps> = ({ model, className }) => {
  const { isTabletOrMobile } = useViewport();
  const { isDark } = useTheme();

  return (
    <div
      className={classNames(
        'rounded-3 d-flex flex-column-reverse flex-md-row p-0 p-md-3 riforma-regular justify-content-between mb-5 overflow-hidden',
        className,
        styles['banner-card'],
        { 'bg-light5': isDark }
      )}
    >
      <div className='w-100 w-md-50 p-4 d-flex flex-column justify-content-between'>
        <div className='w-100 w-md-90'>
          <div className={`fs-22px fs-xs-24px line-height-32px ${isDark ? 'text-light' : 'text-primary'}`}>
            Any questions about the {model.displayName}?
          </div>
          <div className='mb-2 mb-sm-4' />
          <div className={`${isDark ? 'text-light60' : 'text-secondary'} fs-14px line-height-20px`}>
            {`Your designated concierge is always available \n
        to talk watches! Ask them any questions you \n
        have about this model.`}
          </div>
        </div>
        <div className='mb-5 mb-md-8' />
        <Button
          className={`w-100 w-md-90 p-3 border-0 ${isDark ? 'text-light' : 'text-primary'}`}
          variant={isDark ? 'light10' : 'secondary'}
          onClick={intercomShowNewMessage}
        >
          <ChatButtonContent />
        </Button>
      </div>
      <ConciergeVideo className={classNames('w-100 w-md-40 overflow-hidden', styles['concierge-video-container'])}>
        <ModelAvatar
          size={isTabletOrMobile ? 85 : 80}
          model={model}
          className={classNames('position-absolute', styles['model-avatar'])}
        />
      </ConciergeVideo>
    </div>
  );
};
